import { Model as r } from "../../../../model.js";
class t extends r {
  constructor(e) {
    super(), this.code = e.code, this.balance = e.balance, this.currency = e.currency;
  }
}
export {
  t as CashbackAccountModel
};
//# sourceMappingURL=cashbackAccount.model.js.map
